import type { EMapProvider } from "./map-provider";

export interface IAndroidConfig {
  serverUrl: string;
  appName: string;
  appBundleId: string;
  iconFilePath: string | null;
  iconRoundedFileName: string | null;
  splashScreenImageName: string | null;
  splashScreenBackcolor: string;
  targetAndroidVersion: string;
  appVersion: string;
  versionCode: number;
  minimumAndroidVersion: EMinimumAndroidVersion;
  useClearTextTraffic: boolean;
  trustAllCerts: boolean;
  cameraPermissionLabelSettingsId: string | null;
  locationPermissionLabelSettingsId: string | null;
  notificationPermissionLabelSettingsId: string | null;
  bluetoothPermissionLabelSettingsId: string | null;
  firebaseSettingsId: string | null;
  googleMapsSettingsId: string | null;
  /** Map rendering provider for the Android target. Absent → GoogleMaps (backward compatible). */
  mapProvider?: EMapProvider;
  /** Amap settings used when mapProvider is Amap. */
  amapSettingsId?: string | null;
  /**
   * When true the generated app bundles BOTH Google Maps and Amap and the end user picks one
   * at runtime (SetMapProvider); `mapProvider` is then only the default. Requires an
   * `amapSettingsId`. Absent → false: one provider, output unchanged.
   */
  allowEndUserMapProviderChoice?: boolean;
  googlePlayApiSettingsId: string | null;
  gpsTrackingSettingsId: string | null;
  gpsTrackingPermissionLabelSettingsId: string | null;
  gpsTrackingBackgroundPermissionLabelSettingsId: string | null;
  deviceType: 0 | 1 | 2;
  orientation: "landscape" | "portrait" | "any";
  imageFit: "default" | "stretch";
  isHapticEnabled: boolean;
  isSecureScreenModeEnabled: boolean;
  googleRecaptchaAndroidSettingsId: string | null;
  adiRegistrationSettingsId: string | null;
}

export enum EMinimumAndroidVersion {
  Android8 = "26",
  Android9 = "28",
  Android10 = "29",
  Android11 = "30",
  Android12 = "31",
  Android13 = "33",
  Android14 = "34"
}
